import './historical-places.less'
import register from '@kpsys/angularjs-register';
import HistoricalPlacesDataService from './historical-places.data-service';
import historicalPlacesRoutes from './historical-places.routes';

export default register('uc.provenio')
    .config(historicalPlacesRoutes)
    .service(HistoricalPlacesDataService.serviceName, HistoricalPlacesDataService)
    .name();